import { render, staticRenderFns } from "./AddChannel.vue?vue&type=template&id=66960ad2&scoped=true"
import script from "./AddChannel.vue?vue&type=script&lang=js"
export * from "./AddChannel.vue?vue&type=script&lang=js"
import style0 from "./AddChannel.vue?vue&type=style&index=0&id=66960ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66960ad2",
  null
  
)

export default component.exports